
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Asynchronous Thunks ---

// 1. Add Wp Registraion Thunk
export const AddOfficialWARegistration = createAsyncThunk(
    'documentlink/AddWpRegistration',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/whatsapp_data_add/${values.WhaClientName}`,
                {
                    UserName: values.UserName,
                    Password: values.Password,
                    Database: values.Database,
                    Port: values.Port,
                    FolderName: values.FolderName,
                    WhaCount: values.WhaCount,
                    WhaBalCount: values.WhaBalCount,
                    IsAdmin: values.IsAdmin,
                    IsActive: values.IsActive,
                    IsOWNWhatsapp: values.IsOWNWhatsapp,
                    Templates: values.Templates,
                    WhatsAppOffcialWa: values.WhatsAppOffcialWa,
                    DocLink: values.DocLink,
                    WappNo: values.WappNo,
                    APIToken: values.APIToken,
                    PhoneNoID: values.PhoneNoID,
                    VerifyToken: values.VerifyToken,
                }
            );

            if (response.data?.success) {
                return response.data;
            } else {
                const message = response.data?.message || "Registration failed. Please try again.";
                return rejectWithValue(message);
            }
        } catch (error) {
            const message = error.response?.data?.message || "An error occurred during submission";
            return rejectWithValue(message);
        }
    }
);

// 2. Fetch All Wp Registration Clients (GET)
export const fetchAllWpRegistration = createAsyncThunk(
    'whatsapp/fetchAllWpRegistration',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/client_view_All`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch clients");
        }
    }
);

// 3. Update Client Registration
export const UpdateClientRegistration = createAsyncThunk(
    'whatsapp/UpdateClientRegistration',
    async ({ clientId, updatedClient }, { rejectWithValue }) => {
        try {
            const response = await axios.put(
                `${BaseUrl}/client_update/${clientId}`, updatedClient,);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update client");
        }
    }
);

// 4. Delete Client Registration
export const DeleteClientRegistration = createAsyncThunk(
    'whatsapp/DeleteClientRegistrationF',
    async (clientId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/client_delete/${clientId}`);
            return { clientId, message: response.data?.message || "Deleted successfully" };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Error deleting client");
        }
    }
);


// 5. Check WA DB Connection
export const CheckWAConnection = createAsyncThunk(
    'whatsapp/CheckWAConnection',
    async ({ Port, UserName, Password, Database }, { rejectWithValue }) => {
        try {
            const payload = {
                Port: parseInt(Port),
                UserName,
                Password,
                Database,
            };
            const response = await axios.post(`${BaseUrl}/checkConnection`, payload);
            return response.data;
        } catch (error) {
            const message = error.response?.data?.message || "Could not connect to server";
            return rejectWithValue(message);
        }
    }
);

// 1. Add Wp Client Details Thunk
export const AddWpClientDetail = createAsyncThunk(
    'whatsapp/AddWpClientDetail',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${BaseUrl}/clientdt_add/${values.WhaClientName}/${values.WhaSlabDtID}`,
                {
                    WhaCount: values.WhaCount,
                    WhaBalCount: values.WhaBalCount,
                    WhaDate: values.WhaDate,
                    WhaSlabName: values.WhaSlabName,
                });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Error submitting client detail'
            );
        }
    }
);

// 2. Fetch All WhatsApp Client Details (GET)
export const fetchAllWpClientDetails = createAsyncThunk(
    'whatsapp/fetchAllWpClientDetails',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/clientdt_view_All`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Error fetching client details"
            );
        }
    }
);

// 3. Update WP Client Detail Thunk
export const UpdateWpClientDetail = createAsyncThunk(
    'whatsapp/UpdateWpClientDetail',
    async ({ id, updatedClient }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/clientdt_update/${id}`, updatedClient,);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Error updating client detail'
            );
        }
    }
);


// 4. Delete Wp Client DT 
export const DeleteWpClientDetail = createAsyncThunk(
    'whatsapp/DeleteWpClientDetail',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/clientdt_delete/${id}`)
            return { id, message: response.data?.message || "Deleted successfully" };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Error deleting client detail"
            );
        }
    }
);

// 5. Send Client Key Email
export const SendClientKeyEmail = createAsyncThunk(
    'whatsapp/SendClientKeyEmail',
    async (clientId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/SendMail/${clientId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to send email"
            );
        }
    }
);

// --- Redux Slice ---
const WhatsAppRegistration = createSlice({
    name: 'whatsappRegistration',
    initialState: {

        // New State for Add Wp Api Setup
        AddOfficialWAData: null,
        AddOfficialWALoading: false,
        AddOfficialWAError: null,

        // New state for clients list
        WpRegistrationList: [],
        WpRegistrationLoading: false,
        WpRegistrationError: null,

        // New State for Add Wp Client DT
        AddWpClientDetailData: null,
        AddWpClientDetailLoading: false,
        AddWpClientDetailError: null,

        // New state for fetched client details
        WpClientDetailsData: [],
        WpClientDetailsLoading: false,
        WpClientDetailsError: null,

        CheckWAConnectionStatus: null,
        CheckWAConnectionLoading: false,
        CheckWAConnectionError: null,

        // Send Email State
        SendEmailLoading: false,
        SendEmailError: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            // ---- Add Wp Api Setup handler ----
            .addCase(AddOfficialWARegistration.pending, (state) => {
                state.AddOfficialWALoading = true;
                state.AddOfficialWAError = null;
            })
            .addCase(AddOfficialWARegistration.fulfilled, (state, action) => {
                state.AddOfficialWALoading = false;
                state.AddOfficialWAData = action.payload;
            })
            .addCase(AddOfficialWARegistration.rejected, (state, action) => {
                state.AddOfficialWALoading = false;
                state.AddOfficialWAError = action.payload;
            })


            // Handle fetchAllClientsList
            .addCase(fetchAllWpRegistration.pending, (state) => {
                state.WpRegistrationLoading = true;
                state.WpRegistrationError = null;
            })
            .addCase(fetchAllWpRegistration.fulfilled, (state, action) => {
                state.WpRegistrationLoading = false;
                state.WpRegistrationList = action.payload;
            })
            .addCase(fetchAllWpRegistration.rejected, (state, action) => {
                state.WpRegistrationLoading = false;
                state.WpRegistrationError = action.payload;
            })

            .addCase(UpdateClientRegistration.pending, (state) => {
                state.WpRegistrationLoading = true;
                state.WpRegistrationError = null;
            })
            .addCase(UpdateClientRegistration.fulfilled, (state, action) => {
                state.WpRegistrationLoading = false;

                // Optional: Update state locally if needed
                const updatedClient = action.payload;
                const index = state.WpRegistrationList.data.findIndex(
                    (item) => item._id === updatedClient._id
                );
                if (index !== -1) {
                    state.WpRegistrationList.data[index] = updatedClient;
                }
            })
            .addCase(UpdateClientRegistration.rejected, (state, action) => {
                state.WpRegistrationLoading = false;
                state.WpRegistrationError = action.payload;
            })


            .addCase(DeleteClientRegistration.fulfilled, (state, action) => {
                state.WpRegistrationList.data = state.WpRegistrationList.data.filter(
                    (client) => client._id !== action.payload.clientId
                );
            })
            .addCase(DeleteClientRegistration.rejected, (state, action) => {
                state.WpRegistrationError = action.payload;
            })

            // --- Check WA DB Connection handler ---
            .addCase(CheckWAConnection.pending, (state) => {
                state.CheckWAConnectionLoading = true;
                state.CheckWAConnectionError = null;
            })
            .addCase(CheckWAConnection.fulfilled, (state, action) => {
                state.CheckWAConnectionLoading = false;
                state.CheckWAConnectionStatus = action.payload;
            })
            .addCase(CheckWAConnection.rejected, (state, action) => {
                state.CheckWAConnectionLoading = false;
                state.CheckWAConnectionError = action.payload;
            })


            // ---- Add Wp Client DT handler ----
            .addCase(AddWpClientDetail.pending, (state) => {
                state.AddWpClientDetailLoading = true;
                state.AddWpClientDetailError = null;
            })
            .addCase(AddWpClientDetail.fulfilled, (state, action) => {
                state.AddWpClientDetailLoading = false;
                state.AddWpClientDetailData = action.payload;
            })
            .addCase(AddWpClientDetail.rejected, (state, action) => {
                state.AddWpClientDetailLoading = false;
                state.AddWpClientDetailError = action.payload;
            })

            // --- Handle fetchAll Wp Client Details Handler ---
            .addCase(fetchAllWpClientDetails.pending, (state) => {
                state.WpClientDetailsLoading = true;
                state.WpClientDetailsError = null;
            })
            .addCase(fetchAllWpClientDetails.fulfilled, (state, action) => {
                state.WpClientDetailsLoading = false;
                state.WpClientDetailsData = action.payload;
            })
            .addCase(fetchAllWpClientDetails.rejected, (state, action) => {
                state.WpClientDetailsLoading = false;
                state.WpClientDetailsError = action.payload;
            })

            // ---- Update Wp Client DT handler ----
            .addCase(UpdateWpClientDetail.pending, (state) => {
                state.AddWpClientDetailLoading = true;
                state.AddWpClientDetailError = null;
            })
            .addCase(UpdateWpClientDetail.fulfilled, (state, action) => {
                state.AddWpClientDetailLoading = false;
                const updated = action.payload;
                const index = state.WpClientDetailsData.findIndex((el) => el._id === updated._id);
                if (index !== -1) {
                    state.WpClientDetailsData[index] = updated;
                }
            })
            .addCase(UpdateWpClientDetail.rejected, (state, action) => {
                state.AddWpClientDetailLoading = false;
                state.AddWpClientDetailError = action.payload;
            })

            .addCase(DeleteWpClientDetail.fulfilled, (state, action) => {
                const deletedId = action.payload.id;
                state.WpClientDetailsData = state.WpClientDetailsData.filter(
                    (client) => client._id !== deletedId
                );
            })
            .addCase(DeleteWpClientDetail.rejected, (state, action) => {
                state.WpClientDetailsError = action.payload;
            })

            // --- Handle Send Client Key Email ---
            .addCase(SendClientKeyEmail.pending, (state) => {
                state.SendEmailLoading = true;
                state.SendEmailError = null;
            })
            .addCase(SendClientKeyEmail.fulfilled, (state) => {
                state.SendEmailLoading = false;
            })
            .addCase(SendClientKeyEmail.rejected, (state, action) => {
                state.SendEmailLoading = false;
                state.SendEmailError = action.payload;
            });
    }
});

// Export the reducer
export default WhatsAppRegistration.reducer;